import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

const BreadcrumbNav = ({ currentPath, onNavigate, rootLabel }) => {
  const pathSegments = currentPath.split('/').filter(Boolean);

  const handleClick = (path) => {
    onNavigate(path);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          component="button"
          variant="body1"
          onClick={() => handleClick('')}
          sx={{ textDecoration: 'none' }}
        >
          {rootLabel}
        </Link>
        {pathSegments.map((segment, index) => {
          const path = pathSegments.slice(0, index + 1).join('/');
          const isLast = index === pathSegments.length - 1;

          return isLast ? (
            <Typography key={path} color="text.primary">
              {segment}
            </Typography>
          ) : (
            <Link
              key={path}
              component="button"
              variant="body1"
              onClick={() => handleClick(path)}
              sx={{ textDecoration: 'none' }}
            >
              {segment}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbNav; 